import { Grid } from "@mui/material";
import React from "react";

interface FragmentFullContentProps {
    children: React.ReactNode;
}

const FragmentFullContent = ({ children }: FragmentFullContentProps) => {
        return (
        <Grid columns={{ xs: 4, sm: 8, md: 12 }} container sx={{ width: "96%", m: "2%" }} justifyContent="center" alignContent="center" textAlign="center">
          {children}
        </Grid>
    );
};

export default FragmentFullContent;